import { postUpdateProfileUser } from 'services/api/social/user/profile/update';
import * as actionType from './actionTypes';

export const socialUserProfileUpdate = params => dispatch => {
  dispatch(actionType.socialUserProfileUpdateBegin());
  return postUpdateProfileUser(params)
    .then(payload => {
      if (payload.error)
        dispatch(actionType.socialUserProfileUpdateError(payload));
      else
        dispatch(actionType.socialUserProfileUpdateSuccess(params.isPrivate));
    })
    .catch(error => {
      dispatch(actionType.socialUserProfileUpdateError(error));
    });
};
